// extracted by mini-css-extract-plugin
export default {"popover-wrapper":"_1K7Lf","popoverWrapper":"_1K7Lf","root":"_36XG0"};